import Vue from "vue";
import Router from "vue-router";
import Peering from "./view/Peering.vue";
import RegisterSuccess from "./view/RegisterSuccess.vue";
import Success from "./view/Success.vue";

Vue.use(Router);

export default new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "peering",
      component: Peering,
    },
    {
      path: "/registerSuccess",
      name: "registerSuccess",
      component: RegisterSuccess,
    },
    {
      path: "/success",
      name: "success",
      component: Success,
    }
  ],
});
